/**
 * Grand Cove HOA Theme - Main JavaScript Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import MobileMenu from './components/MobileMenu';
import DropdownMenu from './components/DropdownMenu';
import ActivityFilter from './components/ActivityFilter';

/**
 * Initialize theme functionality when DOM is ready
 */
document.addEventListener( 'DOMContentLoaded', function () {

	// Initialize Mobile Menu
	const menuToggle = document.querySelector( '.menu-toggle' );
	if ( menuToggle ) {
		const mobileMenuRoot = document.createElement( 'div' );
		mobileMenuRoot.id = 'mobile-menu-root';
		menuToggle.parentElement.appendChild( mobileMenuRoot );

		const root = ReactDOM.createRoot( mobileMenuRoot );
		root.render( <MobileMenu /> );
	}

	// Initialize Dropdown Menu
	const primaryMenu = document.querySelector( '.primary-menu' );
	if ( primaryMenu ) {
		const dropdownMenuRoot = document.createElement( 'div' );
		dropdownMenuRoot.id = 'dropdown-menu-root';
		primaryMenu.parentElement.appendChild( dropdownMenuRoot );

		const root = ReactDOM.createRoot( dropdownMenuRoot );
		root.render( <DropdownMenu /> );
	}

	// Initialize Activity Filter (client-side filtering + paging on the activities archive)
	new ActivityFilter();

	// Smooth scrolling for anchor links
	const anchorLinks = document.querySelectorAll( 'a[href^="#"]' );
	anchorLinks.forEach( ( link ) => {
		link.addEventListener( 'click', function ( e ) {
			const targetId = this.getAttribute( 'href' );
			if ( targetId !== '#' && targetId.length > 1 ) {
				const targetElement = document.querySelector( targetId );
				if ( targetElement ) {
					e.preventDefault();
					targetElement.scrollIntoView( {
						behavior: 'smooth',
						block: 'start'
					} );
				}
			}
		} );
	} );

	// Add active class to current menu item
	const currentUrl = window.location.href;
	const menuLinks = document.querySelectorAll( '.primary-menu a, .footer-menu a' );
	menuLinks.forEach( ( link ) => {
		if ( link.href === currentUrl ) {
			link.parentElement.classList.add( 'current-menu-item' );
		}
	} );

	// Mobile menu toggle functionality
	if ( menuToggle ) {
		menuToggle.addEventListener( 'click', function () {
			const navigation = document.querySelector( '.main-navigation' );
			const isExpanded = this.getAttribute( 'aria-expanded' ) === 'true';

			this.setAttribute( 'aria-expanded', ! isExpanded );
			navigation.classList.toggle( 'toggled' );
		} );
	}

	// Close mobile menu when clicking outside
	document.addEventListener( 'click', function ( e ) {
		const navigation = document.querySelector( '.main-navigation' );
		const menuToggle = document.querySelector( '.menu-toggle' );

		if ( navigation && menuToggle && navigation.classList.contains( 'toggled' ) ) {
			if ( ! navigation.contains( e.target ) && ! menuToggle.contains( e.target ) ) {
				navigation.classList.remove( 'toggled' );
				menuToggle.setAttribute( 'aria-expanded', 'false' );
			}
		}
	} );

	// Mobile submenu toggle
	const menuItemsWithChildren = document.querySelectorAll( '.menu-item-has-children' );
	menuItemsWithChildren.forEach( ( item ) => {
		const link = item.querySelector( 'a' );

		// Add toggle button for mobile
		if ( window.innerWidth <= 768 ) {
			const toggleBtn = document.createElement( 'button' );
			toggleBtn.classList.add( 'submenu-toggle' );
			toggleBtn.innerHTML = '<span class="submenu-toggle-icon" aria-hidden="true">+</span>';
			toggleBtn.setAttribute( 'aria-label', 'Toggle submenu' );
			toggleBtn.setAttribute( 'aria-expanded', 'false' );
			toggleBtn.setAttribute( 'type', 'button' );

			// Place the toggle BEFORE the link so it sits at the start of the row
			link.parentNode.insertBefore( toggleBtn, link );

			toggleBtn.addEventListener( 'click', function ( e ) {
				e.preventDefault();
				e.stopPropagation();
				const isToggled = item.classList.toggle( 'toggled' );
				this.setAttribute( 'aria-expanded', isToggled ? 'true' : 'false' );
				this.querySelector( '.submenu-toggle-icon' ).textContent = isToggled ? '−' : '+';
			} );
		}
	} );

	// Keyboard navigation for dropdowns
	const menuItems = document.querySelectorAll( '.primary-menu > li' );
	menuItems.forEach( ( item ) => {
		const link = item.querySelector( 'a' );

		link.addEventListener( 'keydown', function ( e ) {
			const submenu = item.querySelector( '.sub-menu' );

			if ( submenu ) {
				// Open submenu on Enter or Space
				if ( e.key === 'Enter' || e.key === ' ' ) {
					e.preventDefault();
					submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
				}

				// Close submenu on Escape
				if ( e.key === 'Escape' ) {
					submenu.style.display = 'none';
					link.focus();
				}
			}
		} );
	} );

	// Sticky header on scroll
	let lastScrollTop = 0;
	const header = document.querySelector( '.site-header' );

	window.addEventListener( 'scroll', function () {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if ( scrollTop > lastScrollTop && scrollTop > 100 ) {
			// Scrolling down
			header.style.transform = 'translateY(-100%)';
		} else {
			// Scrolling up
			header.style.transform = 'translateY(0)';
		}

		lastScrollTop = scrollTop;
	} );

	// Add transition to header
	if ( header ) {
		header.style.transition = 'transform 0.3s ease';
	}

	console.log( 'Grand Cove HOA Theme initialized' );
} );

// Handle window resize
let resizeTimer;
window.addEventListener( 'resize', function () {
	clearTimeout( resizeTimer );
	resizeTimer = setTimeout( function () {
		// Reset mobile menu on resize
		const navigation = document.querySelector( '.main-navigation' );
		const menuToggle = document.querySelector( '.menu-toggle' );

		if ( window.innerWidth > 768 && navigation ) {
			navigation.classList.remove( 'toggled' );
			if ( menuToggle ) {
				menuToggle.setAttribute( 'aria-expanded', 'false' );
			}
		}
	}, 250 );
} );
